// State
import { getAutocompleteState } from '../state/autocompleteState'

// Axios
import axios from 'axios'

// Config
import endpoints from '../config/endpoints'

const getAcoommodations = async (searchText: string, locale: string): Promise<[{ [key: string]: string }]> => {
    try {
        if (!locale) throw new Error('locale is mandatory in getAcoommodations')
        const { data } = await axios.post(
            endpoints.searchLihes,
            { liheName: searchText },
            {
                params: { size: 10 },
                headers: {
                    'Accept-Language': locale
                }
            }
        )
        const {state} = getAutocompleteState()
        state.madeAccommodationsRequest = true

        return data
    } catch (err) {
        throw err
    }
}

export default getAcoommodations
